import { Component, OnInit, ViewEncapsulation, Inject, PLATFORM_ID, OnDestroy } from '@angular/core';
import { Stockitem } from '../../../../interfaces/stockitem';
import { AdvancedStocksService } from '../../../../services/advancedstocksservice';
import { isPlatformBrowser } from '@angular/common';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { CartService } from '../../../../services/cart';
import { DailyOfferStateService } from '../../../../services/dailyOfferState';
import { Router } from '@angular/router';
import { UrlSlugifyService } from '../../../../services/url-slugify';

@Component({
  selector: 'app-dailyoffers',
  templateUrl: './dailyoffers.component.html',
  styleUrls: ['./dailyoffers.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DailyoffersComponent implements OnInit {

  isAr = false;
  isMobile = false;
  showOffer = false;
  showFloatingChip = false;

  brandOfferProducts: Stockitem[] = [];


  private isBrowser: boolean;

  constructor(
    private advancedStocks: AdvancedStocksService,
    private router: Router,
    private deviceService: DeviceDetectorService,
    private _slugify: UrlSlugifyService,
    private cartService: CartService,
    public dailyOfferState: DailyOfferStateService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (!this.isBrowser) return;

    this.isAr = localStorage.getItem('language') === 'ar';
    this.isMobile = this.deviceService.isMobileDevice();

    // 🔥 المصدر الوحيد
    this.loadDailyOffer();
  }
  addToCart(element: any, event?: Event) {
    if (event) event.stopPropagation();

    this.cartService.addToCart(element);
  }



  // ================= DAILY OFFER =================
  loadDailyOffer(): void {
    this.advancedStocks.getDailyOffer().subscribe({
      next: (res: any) => {

        const products = res.products || [];

        // 🔥 خد أول 2 بس
        this.brandOfferProducts = products.slice(0, 1);

        if (this.brandOfferProducts.length === 0) {
          this.showOffer = false;
          return;
        }

        this.showFloatingChip = false;
        this.dailyOfferState.start();
      },
      error: (err) => {
        console.error('Daily offer error', err);
      }
    });
  }


  goToDailyOffers(): void {
    this.close();
    this.router.navigate(['/dailyoffers']);
  }

  // ================= UI =================
  close(): void {
    this.dailyOfferState.showOffer$.next(false);
    this.showFloatingChip = true;
  }
  productDetails(product: any) {
    this.router.navigate(['/product', this._slugify.slugify(product.name_en), product.id]);
    this.close()
  }

  reopen(): void {
    this.dailyOfferState.showOffer$.next(true);
    this.showFloatingChip = false;
  }


  calcDis(newP: any, oldP: any): number {
    const off = Math.round(((parseInt(oldP) - parseInt(newP)) / parseInt(oldP)) * 100);
    return isNaN(off) ? 0 : off;
  }

  fixImage(url: any): string {
    return 'https://backendproduction.blueboxpet.com/storage/app/public/' + url;
  }
}
